export type RenderIfConditionIsMetProps = {
  condition: boolean
  children: React.ReactNode
}

export function RenderIfConditionIsMet({condition, children}: RenderIfConditionIsMetProps) {
  return condition ? children : <></>
}
